import gql from "graphql-tag";

export const PAVING_FOREMANS_QUERY = gql`
  query pavingForemans {
    pavingForemans {
      uID
      username
	  }
  }
`;